import { render, staticRenderFns } from "./cookies.vue?vue&type=template&id=56be21e8&scoped=true"
import script from "./cookies.vue?vue&type=script&lang=js"
export * from "./cookies.vue?vue&type=script&lang=js"
import style0 from "./cookies.vue?vue&type=style&index=0&id=56be21e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56be21e8",
  null
  
)

export default component.exports